package app.credit

import app.creditForm
import app.properties.Credit
import app.properties.axiosPost
import app.settings.backendPath
import kotlinx.html.js.onClickFunction
import kotlinx.html.title
import org.w3c.dom.get
import react.*
import react.dom.a
import react.dom.div
import react.dom.i
import react.dom.jsStyle
import kotlin.browser.localStorage
import kotlin.browser.window

interface CreditItemProps : RProps {
    var credit: Credit
    var id: Int
}
interface CreditItemState : RState {
    var editStatus: Boolean
}

class CreditItem(props: CreditItemProps) : RComponent<CreditItemProps, CreditItemState>(props) {

    init {
        state.editStatus = false
    }

    fun afterRequest(status: Boolean) {
        setState { editStatus = status }
    }

    override fun RBuilder.render() {
        div("row creditItem") {
            div("col-1") {
                attrs.title = "${props.credit.id}"
                +"${props.credit.hh}"
            }
            div("col") {
                div("row") {
                    div("col") {
                        if(props.credit.company?.name != null) {
                            +"${props.credit.company?.name}"
                        } else {
                            +"${props.credit.person?.firstName}"
                        }
                    }
                    div("col") {
                        if(props.credit.company?.name != null) {
                            +""
                        } else {
                            +"${props.credit.person?.lastName}"
                        }
                    }
                    div("col") {
                        if(props.credit.status == "") {
                            +"Դիմում"
                        } else {
                            +"${props.credit.status}"
                        }
                    }
                    div("col") {
                        +"${props.credit.person?.region?.name}"
                    }
                    div("col") {
                        +"${props.credit.cdate}"
                    }
                    div("col") {
                        +"${props.credit.creditType?.name}"
                    }
                }
            }
            div("col-1") {
                div("row") {
                    div("col") {
                        i ("fa fa-edit") {

                            attrs {
                                jsStyle {
                                    cursor = "pointer"
                                    padding = "2px"
                                }
                                onClickFunction = {
                                    setState {
                                        editStatus = !editStatus
                                    }
                                }
                            }

                        }
                        if(localStorage.get("type") == "0") {
                            i ("fa fa-trash-alt") {

                                attrs.jsStyle {
                                    cursor = "pointer"
                                    padding = "2px"
                                }
                                attrs.onClickFunction = {
                                    if(kotlin.browser.window.confirm("Ջնջել?")) {
                                        axiosPost(backendPath + "/deleteCredit", object { val id = props.credit.id}).then {
                                            if(it.data.status == 200)
                                                window.location.reload()
                                            else
                                                js("alert('Error')")
                                        }
                                    }
                                }

                            }
                        }
                        a {

                            attrs {
                                href = backendPath + "/exportCredit/${props.credit.id}"
                                target = "_blank"
                                jsStyle {
                                    cursor = "pointer"
                                    padding = "2px"
                                }
                            }
                            i("fa fa-upload") {  }

                        }
                    }
                }
            }
        }
        if(state.editStatus) {
            div("row") {
                creditForm(props.credit, fun (status: Boolean) {
                    setState {
                        editStatus = status
                    }
                })
            }
        }
    }
}

fun RBuilder.creditItem(credit: Credit, id: Int) = child(CreditItem::class) {
    attrs.credit = credit
    attrs.id = id
}